import { Button as DevButton } from 'devextreme-react/button';
import { useCallback, useEffect, useState } from "react";
import { bienLaiThuApi } from "../../../api/bienLaiApi";
import { sf_mucphaithu } from "../../../models/response/thu-phi/sf_mucphaithu";
import { Button } from "../../buttons";
import { DefaultPopup } from "../../modal";
import { PlaceHolder } from "../../place-holder";
import styles from './TaoBienLai.module.css'
type ThuPhiTaoBienLaiBtnProps = {
    disabled: boolean,
    sf_mucphaithu: sf_mucphaithu
}
const ThuPhiTaoBienLaiBtn = (props: ThuPhiTaoBienLaiBtnProps) => {
    const [isShowPrint, setIsShowPrint] = useState<boolean>(false)
    return (
        <>
            <DevButton
                text="In biên lai"
                type="default"
                stylingMode="text"
                icon="print"
                className="p-btn-devextreme"
                disabled={props.disabled}
                onClick={() => {
                    setIsShowPrint(true)
                }}
            />
            {isShowPrint && <PrintModal
                sf_mucphaithu={props.sf_mucphaithu}
                onClose={() => { setIsShowPrint(false) }}
            />}
        </>
    )
}
type PrintModalProps = {
    sf_mucphaithu: sf_mucphaithu,
    onClose: () => void
}
export const PrintModal = (props: PrintModalProps) => {
    const [print_url, set_print_url] = useState<string>("")
    const [isLoading, setIsLoading] = useState<boolean>(true)
    useEffect(() => {
        handlePrint();
    }, [props.sf_mucphaithu.id])
    const handlePrint = async () => {
        setIsLoading(true)
        const res = await bienLaiThuApi.print(props.sf_mucphaithu.id);
        if (res.is_success) {
            set_print_url(res.data);
        } else {
            set_print_url("");
        }
        setIsLoading(false)
    }
    const onClose = useCallback(() => {
        window.animationHidePopup("")
        setTimeout(() => {
            props.onClose();
        }, 500);
    }, [])
    return (
        <div className={styles.custom_width}>
            <DefaultPopup
                width={'xxlarge'}
                title="Biên lai thu phí"
                onClose={onClose}
            >
                <div>
                    {isLoading && <PlaceHolder line_number={20} />}
                    {!isLoading &&
                        <div id="embed_print_bienlai">
                            <embed id="embed_print_bienlai" src={print_url} width='1000px' height={window.innerHeight - 250} type="application/pdf"></embed>
                        </div>
                    }
                    <div className="pop-up-actions">
                        <Button type="normal" text="Đóng" onClick={props.onClose} />
                    </div>
                </div>
            </DefaultPopup>
        </div>


    )
}
export default ThuPhiTaoBienLaiBtn